import styled from '@emotion/styled';
import { Colors, MoneyInput } from 'goalsetter-webapp-components';

export const IconContainer = styled.div<{ isOdd?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.isOdd ? Colors.ORANGE : Colors.BLUE_INVESTMENTS};
`;

export const StyledMoneyInput = styled(MoneyInput)<{ limitexeeded?: boolean }>`
  width: 90px;
  & input {
    text-align: center;
    border: ${(props) =>
      props.limitexeeded
        ? `2px solid ${Colors.RED}`
        : `1px solid ${Colors.GRAY}`};
    outline: none;
    box-shadow: none;
  }
  & input:focus {
    border: ${(props) =>
      props.limitexeeded
        ? `2px solid ${Colors.RED}`
        : `1px solid ${Colors.GRAY}`};
  }
`;

export const WishImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50px;
`;

export const mainWrapperStyle = { paddingTop: '16px' };
export const iconAndTextGap = { gap: '16px' };
export const moneyInputStyle = { width: '90px' };
